// extracted by mini-css-extract-plugin
export default {"title":"title_CardHeader-module_vJc0P","totalSubmissions":"totalSubmissions_CardHeader-module_aE7_o","resultsLink":"resultsLink_CardHeader-module_oEXRU"};